import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from '../ui/CommandPalette';
import { ToastRenderer } from '../ui/Toast';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';
import CreateSOPModal from '../CreateSOPModal';
import { EXTENSION_BANNER_OPEN_INSTALL_MODAL_EVENT } from '../../constants/extensionInstall';
import WelcomeWalkthrough from '../onboarding/WelcomeWalkthrough';
import { useWelcomeWalkthroughContext } from '../../contexts/WelcomeWalkthroughContext';
export function Layout() {
    useKeyboardShortcuts();
    const { walkthrough, walkthroughOpen, requestOpenWalkthrough, selectStep, onSkip, onComplete, onClose, } = useWelcomeWalkthroughContext();
    const [createSopOpen, setCreateSopOpen] = useState(false);
    const [createSopSource, setCreateSopSource] = useState(null);
    const [createSopView, setCreateSopView] = useState(null);
    // Allow the ExtensionBanner (mounted anywhere in the tree) to open the
    // modal directly into the install-guide view.
    useEffect(() => {
        const openInstall = () => {
            setCreateSopSource('sidebar');
            setCreateSopView('install');
            setCreateSopOpen(true);
        };
        window.addEventListener(EXTENSION_BANNER_OPEN_INSTALL_MODAL_EVENT, openInstall);
        return () => {
            window.removeEventListener(EXTENSION_BANNER_OPEN_INSTALL_MODAL_EVENT, openInstall);
        };
    }, []);
    return (_jsxs("div", { className: "app-layout", children: [_jsx(Sidebar, { onTakeTour: () => requestOpenWalkthrough({ source: 'sidebar' }), takeTourDisabled: walkthroughOpen }), _jsxs("div", { className: "app-main", children: [_jsx(Header, {}), _jsxs("main", { className: "app-content", children: [_jsx(WelcomeWalkthrough, { open: walkthroughOpen, currentStep: walkthrough.currentStep, totalSteps: walkthrough.totalSteps, onSelectStep: selectStep, onNext: walkthrough.next, onPrevious: walkthrough.previous, onSkip: onSkip, onComplete: onComplete, onClose: onClose }), _jsx(Outlet, {})] })] }), _jsx(CommandPalette, {}), _jsx(ToastRenderer, {}), _jsx(CreateSOPModal, { open: createSopOpen, source: createSopSource ?? undefined, initialView: createSopView ?? undefined, onClose: () => {
                    setCreateSopOpen(false);
                    setCreateSopSource(null);
                    setCreateSopView(null);
                } })] }));
}
